import { render, staticRenderFns } from "./PopOrderUrgent.vue?vue&type=template&id=1125a68f&scoped=true&"
import script from "./PopOrderUrgent.vue?vue&type=script&lang=js&"
export * from "./PopOrderUrgent.vue?vue&type=script&lang=js&"
import style0 from "./PopOrderUrgent.vue?vue&type=style&index=0&id=1125a68f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1125a68f",
  null
  
)

export default component.exports